import React, { FC } from 'react';
import moment from 'moment';
import translate from '@translate';
import { styled } from '@mui/material/styles';
import DateTimePicker, { PropValueType } from 'src/components/DateTimePicker';
import Tooltip from '../../components/Tooltip';
import { InfoIcon } from '../../components/SkladonIcon/Icons';
import {
    getRequiredExpeditionDateError,
    getRequiredExpeditionMinDate,
    isRequiredExpeditionDateDisabledDay,
    isRequiredExpeditionDateEditable,
} from './requiredExpeditionDate';

const InfoIconStyled = styled('span')({
    marginLeft: '10px',

    '& svg': {
        width: '14px',
        height: '14px',
        marginRight: '10px',
    },
});

export interface RequiredExpeditionDateFieldPropsType {
    value?: PropValueType;
    originalValue?: PropValueType;
    status?: string | null;
    disableEdit: boolean;
    summary?: boolean;
    error?: boolean;
    onChange: (value: PropValueType, error: boolean) => void;
}

const RequiredExpeditionDateField: FC<RequiredExpeditionDateFieldPropsType> = (props) => {
    const editable = isRequiredExpeditionDateEditable(props.status, props.disableEdit, Boolean(props.summary));
    const computeError = (value: PropValueType) =>
        getRequiredExpeditionDateError(value, props.originalValue, { editable, now: moment() });

    return (
        <DateTimePicker
            value={props.value}
            name={'REQUIRED_EXPEDITION_DATE'}
            error={props.error}
            onError={(_rawError, value) => {
                // MUI validates on mount too; ignore its raw error and report only changes of our own result
                const error = computeError(value);
                if (error !== Boolean(props.error)) {
                    props.onChange(value, error);
                }
            }}
            onChange={(value) =>
                props.onChange(value && typeof value !== 'string' ? moment(value).format('YYYY-MM-DD') : null, computeError(value))
            }
            label={
                <>
                    {translate('orderDetail.requiredExpeditionDate')}
                    <Tooltip title={translate('orderDetail.requiredExpeditionDate.tooltip')}>
                        <InfoIconStyled>
                            <InfoIcon />
                        </InfoIconStyled>
                    </Tooltip>
                </>
            }
            fullWidth
            type="date"
            disabled={!editable}
            disablePast={editable ? true : undefined}
            minDate={editable ? getRequiredExpeditionMinDate(moment()) : undefined}
            shouldDisableDate={editable ? isRequiredExpeditionDateDisabledDay : undefined}
        />
    );
};

export default RequiredExpeditionDateField;
